// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2Mdvd","col":"styles_col__TqTMb"};